import { useCallback, useRef } from 'react';

import { TINYAI_CONSTANTS } from '../constants';

interface UseSwipeToCloseOptions {
  onClose?: () => void;
}

export const useSwipeToClose = ({ onClose }: UseSwipeToCloseOptions) => {
  const touchStartY = useRef<number>(0);
  const swipeTriggered = useRef<boolean>(false);

  const triggerSwipeClose = useCallback(() => {
    if (swipeTriggered.current) return;
    swipeTriggered.current = true;
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  const onTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartY.current = e.touches[0].clientY;
    swipeTriggered.current = false;
  }, []);

  const onTouchMove = useCallback(
    (e: React.TouchEvent) => {
      const currentY = e.touches[0].clientY;
      const swipeDistance = currentY - touchStartY.current;
      if (swipeDistance > TINYAI_CONSTANTS.SWIPE_THRESHOLD) {
        triggerSwipeClose();
      }
    },
    [triggerSwipeClose],
  );

  const onTouchEnd = useCallback(
    (e: React.TouchEvent) => {
      const touchEndY = e.changedTouches[0].clientY;
      const swipeDistance = touchEndY - touchStartY.current;
      if (swipeDistance > TINYAI_CONSTANTS.SWIPE_THRESHOLD) {
        triggerSwipeClose();
      }
    },
    [triggerSwipeClose],
  );

  return { onTouchStart, onTouchMove, onTouchEnd };
};
